var map = {
	"./Anyswap.png": 55947,
	"./Anyswap.svg": 55152,
	"./Artwork.svg": 56287,
	"./Artwork_gmx.svg": 10641,
	"./Banxa.png": 15194,
	"./BinanceCoin_40.svg": 37026,
	"./CoinMarketCap.png": 48298,
	"./ConfirmArrowDownImage.svg": 27363,
	"./DROP_DOWN.svg": 18692,
	"./EarnIcGlp40.svg": 72886,
	"./EarnIcGmx40.svg": 80766,
	"./EcosystemBookmark.svg": 10732,
	"./EcosystemCoins.svg": 9501,
	"./EcosystemFantomImage.svg": 21463,
	"./EcosystemGMX.svg": 51888,
	"./EcosystemHeartHandShake.svg": 65955,
	"./EcosystemTelegramPlane.svg": 75494,
	"./Ethereum_40.svg": 24003,
	"./ExchangeChartMainPriceImage1.svg": 20591,
	"./ExchangeChartMainPriceImage2.svg": 25044,
	"./FooterLogo.svg": 50962,
	"./Hop.png": 79577,
	"./Hop.svg": 68415,
	"./Hop_dark.png": 20815,
	"./Hop_dark.svg": 45106,
	"./Litecoin_40.svg": 56197,
	"./NetworkCheckImage.svg": 32218,
	"./Pot.svg": 40670,
	"./ReferralsAlertTriangle.svg": 21231,
	"./ReferralsConnectAccountWalletImage.svg": 2895,
	"./ReferralsDisconnectAccountWalletImage.svg": 48849,
	"./Skeleton.svg": 48863,
	"./Solana_40.svg": 48813,
	"./StakeV2Coins.svg": 6572,
	"./StakeV2TrendingUp.svg": 1762,
	"./StakeV2Wallet.svg": 90849,
	"./Stars.svg": 86570,
	"./Synapse.png": 3935,
	"./Synapse.svg": 73391,
	"./Tether_40.svg": 9835,
	"./TradersSearchImage.svg": 31680,
	"./TradesPosition1Image.svg": 57087,
	"./TradesPosition2Image.svg": 83474,
	"./TradesPosition3Image.svg": 68122,
	"./VLPToken.png": 42435,
	"./VMXETHImage.svg": 19458,
	"./VMXFTMImage.svg": 63486,
	"./VMXLogo.svg": 24783,
	"./VMXToken.png": 50353,
	"./VoodooGirlImage.png": 64200,
	"./arrowRight.svg": 16704,
	"./binance.png": 66030,
	"./bitkeep.svg": 42267,
	"./bscscan.png": 81128,
	"./btn_big_arbitrum.png": 70756,
	"./btn_big_avalanche.png": 11784,
	"./btn_big_bsc.png": 74872,
	"./btn_big_purchasegmx.png": 43760,
	"./btn_big_purchasegmx.svg": 12346,
	"./buy_gmx.svg": 59709,
	"./buy_gmx_bond.svg": 17868,
	"./buy_transfer_eth.svg": 66961,
	"./checkboxYellowCheckedDisabledImage.svg": 92009,
	"./checkboxYellowCheckedImage.svg": 58831,
	"./checkboxYellowImage.svg": 48195,
	"./clearButtonImage.svg": 56166,
	"./coinbaseWallet.png": 32346,
	"./coingecko.png": 64993,
	"./cross.svg": 77150,
	"./dashboards.svg": 36683,
	"./deBank.svg": 44951,
	"./defiLlama.svg": 75714,
	"./discord-v2.svg": 33077,
	"./discordImage.svg": 50966,
	"./dopex.svg": 18633,
	"./esVMXToken.png": 89654,
	"./exchangeSwapWalletImage.svg": 15791,
	"./flag_de.svg": 10192,
	"./flag_en.svg": 49124,
	"./flag_es.svg": 95372,
	"./flag_fr.svg": 60839,
	"./flag_ja.svg": 44850,
	"./flag_ko.svg": 85160,
	"./flag_ru.svg": 76176,
	"./flag_zh.svg": 85896,
	"./gateio.svg": 33610,
	"./glp_icon.svg": 3689,
	"./gmx-logo-final-white-small.png": 60860,
	"./gmx-logo-final-white.png": 17638,
	"./gmx-logo-final.png": 66289,
	"./gmx-logo-glow.png": 26844,
	"./gmx-logo-with-name.svg": 37058,
	"./gmx_logo.svg": 44368,
	"./goldArrow.svg": 81732,
	"./graphite-01.png": 26020,
	"./ic-communityproject.svg": 78046,
	"./ic_1inch.svg": 67772,
	"./ic_across.svg": 13289,
	"./ic_arbitrum_16.svg": 41898,
	"./ic_arbitrum_24.svg": 79762,
	"./ic_arbitrum_96.svg": 99060,
	"./ic_arbitrum_hover_16.svg": 48133,
	"./ic_arrowleft16.svg": 71774,
	"./ic_arrowright16.svg": 95143,
	"./ic_avalanche_16.svg": 5412,
	"./ic_avalanche_24.svg": 84820,
	"./ic_avalanche_96.svg": 90742,
	"./ic_avalanche_testnet_16.svg": 82300,
	"./ic_avalanche_testnet_24.svg": 82744,
	"./ic_avalanche_testnet_96.svg": 71045,
	"./ic_avax_24.svg": 90750,
	"./ic_avax_30.svg": 10506,
	"./ic_avax_40.svg": 22807,
	"./ic_banxa.svg": 75136,
	"./ic_base_16.svg": 35051,
	"./ic_base_24.svg": 51390,
	"./ic_base_96.svg": 27318,
	"./ic_binance.svg": 57424,
	"./ic_binance_logo.svg": 85685,
	"./ic_bondprotocol_arbitrum.svg": 39016,
	"./ic_bsc.svg": 47680,
	"./ic_bsc_96.svg": 65163,
	"./ic_btc.b_24.svg": 68279,
	"./ic_btc.b_40.svg": 91709,
	"./ic_btc_24.svg": 49351,
	"./ic_btc_40.svg": 80543,
	"./ic_bungee.png": 58595,
	"./ic_busd_24.svg": 99823,
	"./ic_buy_glp.svg": 9333,
	"./ic_bybit.svg": 37557,
	"./ic_cash.png": 33795,
	"./ic_cash.svg": 42531,
	"./ic_checked.svg": 21019,
	"./ic_coingecko_16.svg": 85613,
	"./ic_coingecko_hover_16.svg": 29277,
	"./ic_convert_down.svg": 34935,
	"./ic_copy_16.svg": 15603,
	"./ic_cost.svg": 97906,
	"./ic_dai_24.svg": 86592,
	"./ic_dai_40.svg": 9641,
	"./ic_discord.svg": 21797,
	"./ic_dodo.svg": 13394,
	"./ic_eth_24.svg": 47639,
	"./ic_eth_40.svg": 78432,
	"./ic_firebird.png": 83041,
	"./ic_frax_24.svg": 5790,
	"./ic_frax_40.svg": 90630,
	"./ic_ftm_16.svg": 54674,
	"./ic_ftm_24.svg": 55245,
	"./ic_ftm_40.svg": 34286,
	"./ic_ftm_96.svg": 23018,
	"./ic_gitbook.svg": 54083,
	"./ic_github.svg": 27467,
	"./ic_glp_24.svg": 98052,
	"./ic_glp_40.svg": 43798,
	"./ic_glp_arbitrum.svg": 28281,
	"./ic_glp_avax.svg": 39834,
	"./ic_glp_custom.svg": 82842,
	"./ic_gmx.svg": 81790,
	"./ic_gmx_24.svg": 86268,
	"./ic_gmx_30.svg": 49772,
	"./ic_gmx_40.svg": 572,
	"./ic_gmx_64.svg": 36172,
	"./ic_gmx_arbitrum.svg": 75356,
	"./ic_gmx_avax.svg": 92967,
	"./ic_gmx_big.svg": 42876,
	"./ic_gmx_custom.svg": 55133,
	"./ic_gmx_footer.svg": 21986,
	"./ic_hop.svg": 86934,
	"./ic_huobi.svg": 94052,
	"./ic_info.svg": 38628,
	"./ic_kucoin.svg": 9039,
	"./ic_kyberswap.svg": 22502,
	"./ic_language24.svg": 71085,
	"./ic_link_24.svg": 88956,
	"./ic_link_40.svg": 79529,
	"./ic_liquidity.svg": 76738,
	"./ic_matcha.png": 71243,
	"./ic_medium.svg": 57488,
	"./ic_menu_dots.svg": 64337,
	"./ic_metamask_16.svg": 31356,
	"./ic_metamask_hover_16.svg": 68177,
	"./ic_mim_24.svg": 95643,
	"./ic_mim_40.svg": 17928,
	"./ic_multiswap.svg": 49215,
	"./ic_new_link_16.svg": 60613,
	"./ic_o3.png": 36666,
	"./ic_odos.png": 82284,
	"./ic_olympus.svg": 39219,
	"./ic_olympus_arbitrum.svg": 17682,
	"./ic_openocean.svg": 87132,
	"./ic_paraswap.svg": 35071,
	"./ic_selector_dropdowns.svg": 31370,
	"./ic_settings_16.svg": 88317,
	"./ic_settings_24.svg": 94240,
	"./ic_sign in_16.svg": 37516,
	"./ic_sign_out_16.svg": 98741,
	"./ic_simpleswaps.svg": 50240,
	"./ic_slingshot.svg": 93149,
	"./ic_stats.svg": 98865,
	"./ic_stats_big.svg": 39236,
	"./ic_synapse.svg": 56993,
	"./ic_tansak.svg": 61856,
	"./ic_telegram.svg": 50933,
	"./ic_tether_24.svg": 8466,
	"./ic_tokens.svg": 12870,
	"./ic_totaluser.svg": 26141,
	"./ic_traderjoe.png": 81157,
	"./ic_traderjoe_avax.png": 54767,
	"./ic_trading.svg": 35095,
	"./ic_transfer_avax.svg": 54478,
	"./ic_twitter.svg": 16396,
	"./ic_uni_24.svg": 61691,
	"./ic_uni_40.svg": 79812,
	"./ic_uni_arbitrum.svg": 78610,
	"./ic_unidex.png": 82740,
	"./ic_usdc.e_24.svg": 40890,
	"./ic_usdc.e_40.svg": 14206,
	"./ic_usdc_24.svg": 8038,
	"./ic_usdc_40.svg": 1924,
	"./ic_usdcm_24.svg": 32750,
	"./ic_usdcm_40.svg": 21955,
	"./ic_usdt_24.svg": 17039,
	"./ic_usdt_40.svg": 59757,
	"./ic_verified.svg": 34872,
	"./ic_wallet_24.svg": 75395,
	"./ic_wavax_24.svg": 62690,
	"./ic_wavax_40.svg": 29994,
	"./ic_wbtc_24.svg": 93205,
	"./ic_wbtc_40.svg": 50195,
	"./ic_weth_24.svg": 9151,
	"./ic_weth_40.svg": 8521,
	"./ic_wftm_24.svg": 78139,
	"./ic_wftm_40.svg": 58679,
	"./ic_yield_yak.png": 81411,
	"./icons8-medium.svg": 54570,
	"./image-skill.svg": 77647,
	"./info.svg": 61490,
	"./laChartArea.svg": 41862,
	"./laHandHoldingUsd.svg": 44165,
	"./la_arrow-right.svg": 90683,
	"./la_exchange-alt.svg": 4807,
	"./la_facebook-f.svg": 6402,
	"./la_instagram.svg": 62352,
	"./la_twitter-gray.svg": 81887,
	"./la_twitter.svg": 31588,
	"./la_wallet_yellow.svg": 64704,
	"./lg_arbitrum.svg": 96276,
	"./logo_GMX.svg": 20334,
	"./logo_GMX_small.svg": 19156,
	"./long.svg": 54905,
	"./longYellow.svg": 64400,
	"./metamask-text.svg": 78232,
	"./metamask.png": 46521,
	"./nansen_portfolio.svg": 73345,
	"./ordersImage.svg": 80527,
	"./page-not-found.svg": 39014,
	"./position-share-bg.png": 59430,
	"./positionsImage.svg": 75137,
	"./rook.svg": 12950,
	"./selectOrderArrowImage.svg": 18321,
	"./short.svg": 28800,
	"./shortYellow.svg": 31639,
	"./swap.svg": 1630,
	"./swapYellow.svg": 37337,
	"./swapYellowRectangle.svg": 57449,
	"./telegram.svg": 60767,
	"./telegramImage.svg": 92635,
	"./tradesImage.svg": 6159,
	"./trading.jpg": 30393,
	"./voodooLogo.svg": 60472,
	"./wallet-connect-text.svg": 51812,
	"./walletconnect-circle-blue.svg": 68891,
	"./wave-01.png": 49338,
	"./wave-02.png": 55046,
	"./zealy.svg": 16000
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 51327;